module.exports = __webpack_public_path__ + "static/media/logoihara.5b519a8f.png";